
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChitPayment, InterestPayment } from "@/lib/types";

interface PaymentsListProps {
  title: string;
  description: string;
  payments: ChitPayment[] | InterestPayment[];
  type: "chit" | "interest";
}

const PaymentsList = ({ title, description, payments, type }: PaymentsListProps) => {
  const navigate = useNavigate();

  const handleNavigate = (id: string) => {
    if (type === "chit") {
      navigate(`/chit-pools/${id}`);
    } else {
      navigate(`/loans/${id}`);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        {payments && payments.length > 0 ? (
          <div className="space-y-4">
            {payments.map((payment) => (
              <div key={payment.id} className="flex justify-between items-center border-b pb-3">
                <div>
                  <p className="font-medium">
                    {type === "chit" 
                      ? (payment as any).chit_pool?.name || "Unknown Chit Pool"
                      : (payment as any).loan?.customer_name || "Unknown Customer"}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {format(new Date(payment.reminder_date), "MMMM dd, yyyy")}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => handleNavigate(type === "chit" 
                      ? (payment as ChitPayment).chit_pool_id 
                      : (payment as InterestPayment).loan_id)}
                  >
                    View Details
                  </Button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <p className="text-muted-foreground">No upcoming {type === "chit" ? "chit" : "interest"} payments</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PaymentsList;
